<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 13 17">
    <path
      d="M2.64884 1.08347C2.64884 0.596728 2.25426 0.202148 1.76752 0.202148C1.28078 0.202148 0.886202 0.596728 0.886202 1.08347V7.2527C0.886202 10.6599 1.76752 13.4219 6.17412 13.4219C10.5807 13.4219 11.462 10.6599 11.462 7.2527V1.08347C11.462 0.596728 11.0675 0.202148 10.5807 0.202148C10.094 0.202148 9.69939 0.596728 9.69939 1.08347V7.2527C9.69939 9.6864 9.69939 11.6593 6.17412 11.6593C2.64884 11.6593 2.64884 9.6864 2.64884 7.2527V1.08347Z"
      :class="colorClass"
    />

    <path
      d="M0.886202 14.3033C0.399463 14.3033 0.00488281 14.6978 0.00488281 15.1846C0.00488281 15.6713 0.399463 16.0659 0.886202 16.0659H11.462C11.9488 16.0659 12.3434 15.6713 12.3434 15.1846C12.3434 14.6978 11.9488 14.3033 11.462 14.3033H0.886202Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
